export const environment = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '',
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
};
